export default "__VITE_ASSET__DoBbX8dU__"